import React, { useState, useEffect, useRef } from "react";

import { AiOutlineInfoCircle } from "react-icons/ai";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import constant from "../../../_config/constant";
import {loadConnectAndInitialize} from '@stripe/connect-js';
import {
    ConnectComponentsProvider,
    ConnectAccountOnboarding
  } from "@stripe/react-connect-js";
import {
    authHeader
  } from "../../../_helpers";
import { bankService } from "../../../_services";
import { is } from "date-fns/locale";

var Modal = require("react-bootstrap-modal");


export const PayoutMethod = ({
  onNext,
  onPrev,
  formData,
  setFormData,
  className,
  saveAsDraft,
  draftRequesting,
  hostDetail,
  setIspaymentConfirm,
  setIsButtonDisable,
  isButtonDisable
}) => {
  const [stepForm, setStepForm] = useState({
    payoutVerfication: 0,
    extraChargePerGuest: formData.extraChargePerGuest,
    perMonthPrice: formData.perMonthPrice,
    cleaningFee: formData.cleaningFee,
    securityDeposite: formData.securityDeposite,
    lineholderDiscountType: formData.lineholderDiscountType,
    lineholderDiscount: formData.lineholderDiscount,
  });

  const valueRef = useRef(formData);

  const elementRef = useRef(null);
  

  useEffect(() => {
    valueRef.current = {...formData}
  }, [formData])

  useEffect(() => {
    const element = elementRef.current;
    if (!element) return;
    
    const observer = new MutationObserver(() => {
      if (element.classList.contains('tw-hidden')) {
        handleComponentDisappear();
      }
    });
    
    observer.observe(element, {
      attributes: true,
      attributeFilter: ['class']
    });
    
    return () => observer.disconnect();
  }, []);

  const handleComponentDisappear = () => {
    setFormData(valueRef.current);
  };

  const [payoutVerified, setPayoutVerified] = useState(null);
  const [payoutAccount, setPayoutAccount] = useState(null);

  const handleStep = (tag, value) => {
    setStepForm({ ...stepForm, [tag]: value });
    valueRef.current = { ...formData, ...stepForm, [tag]: value };
  };

  // /stripe-account-update-payout does not exist on the API - every call to it 404s, and
  // the 404's HTML body then threw inside response.json() before any toast could fire,
  // leaving Next silently disabled forever with no visible error and no way to recover.
  // Check the account the same way Settings > Payout Method already does successfully,
  // and skip the onboarding widget entirely once Stripe confirms the account is verified -
  // a host who already completed this from Settings should not be sent through it again.
  //
  // The Save & Next button below is gated on isButtonDisable, not isPaymentConfirm - the
  // previous success paths here only ever set isPaymentConfirm, so even a successful
  // call could never have enabled it. Both are set together now.
  const checkStripePayoutVerified = async () => {
    const res = await bankService.getStripeDetail();
    return Boolean(res && res.data && res.data.charges_enabled && res.data.payouts_enabled);
  };

  // Mirrors the account summary Settings > Payout Method already shows, using the same
  // fields (bank_name, default_for_currency, routing_number, last4) from the same
  // GET /bank/list response, so a host sees the exact account they already set up rather
  // than a bare "you're verified" message.
  useEffect(() => {
    let cancelled = false;
    checkStripePayoutVerified()
      .then(async verified => {
        if (cancelled) return;
        setPayoutVerified(verified);
        if (!verified) return;
        setIspaymentConfirm(true);
        setIsButtonDisable(true);
        try {
          const res = await bankService.bankList();
          const accounts = res && res.status && res.data && Array.isArray(res.data.data) ? res.data.data : [];
          if (!cancelled) setPayoutAccount(accounts.find(account => account.default_for_currency) || accounts[0] || null);
        } catch (error) {
          // Non-fatal - the verified banner still shows without the bank details.
        }
      })
      .catch(() => {
        if (!cancelled) setPayoutVerified(false);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  // Clicking Save & Next only matters once payoutVerified is already true (that is what
  // enables the button in the first place) - re-querying Stripe here was a redundant
  // network call with no new information to gain, and a transient failure on that extra
  // call alone produced a false "Unable to verify" error for a host already confirmed fine.
  const handleNextStep = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (!payoutVerified) return;
    localStorage.setItem('hostDetailPayout', 1);
    window.scrollTo({ top: 0, behavior: 'smooth' });
    onNext();
  };

  const updateStripeUserAccout = async () => {
    try {
      const verified = await checkStripePayoutVerified();
      if (verified) {
        setIspaymentConfirm(true);
        setIsButtonDisable(true);
        localStorage.setItem('hostDetailPayout', 1);
        window.scrollTo({ top: 0, behavior: 'smooth' });
        onNext();
      } else {
        toast.info('Your payout account is still under review. Please check back shortly.');
      }
    } catch (error) {
      toast.error('Unable to verify Stripe account status. Please try again later.');
    }
  };
  //Stripe Code 
  
  const [stripeConnectInstance] = useState(() => {
    
    const fetchClientSecret = async () => {
      //return "accs_secret__RQTyaKyXymHnukgVBBBMxRu8hbHUtB057FD0YB2eItUjzyw";
      // Fetch the AccountSession client secret
      const response = await fetch(constant.apiUrl+'/stripe-account-create', { method: "GET" , headers: { ...authHeader(), "Content-Type": "application/json" }});
     
      if (!response.ok) {
        // Handle errors on the client side here
        const {error} = await response.json();
        console.error('An error occurred: ', error);
        // document.querySelector('#error').removeAttribute('hidden');
        return undefined;
      } else {
        const data = await response.json();
        //document.querySelector('#error').setAttribute('hidden', '');
        return data.data.client_secret;
      }
    }

    return loadConnectAndInitialize({
      // This is your test publishable API key.
      //replace this with env var while pushing code note-deploy
      publishableKey:  process.env.REACT_APP_STRIPE_API_KEY,// "pk_test_51Iu3xqBryti39zXvQNb9k2efXmKmEpiKqyXcS13X45bqOtmk9UCKzRKZX5CEuOUl0WArEm6W0SJkLIhFxOIf7EsX006Ltaz5Gz",: "pk_test_51Iu3xqBryti39zXvQNb9k2efXmKmEpiKqyXcS13X45bqOtmk9UCKzRKZX5CEuOUl0WArEm6W0SJkLIhFxOIf7EsX006Ltaz5Gz",
      fetchClientSecret: fetchClientSecret,
    })
  });
  //Stripe Code
  const saveAsdraft = (e) => {
    // if (
    //   stepForm.perNightPrice <= 0 ||
    //   stepForm.perMonthPrice <= 0 ||
    //   stepForm.securityDeposite <= 0 ||
    //   stepForm.extraChargePerGuest <= 0
    // ) {
    //   toast.info("Prices cannot be zero or less.");
    //   return;
    // }
    setFormData({ ...formData, ...stepForm });
    saveAsDraft();
  };
  return (
    <form onSubmit={handleNextStep}>
      <div className={className}  ref={elementRef}>
        <div>
          <h4 className="mb-5 tw-flex tw-justify-start tw-items-center">
            <span className="tw-bg-[#23426e] tw-mr-2 tw-flex tw-justify-center tw-items-center  tw-h-10 tw-w-10 tw-text-white  tw-rounded-full">
              11
            </span>{" "}
            Payout Method
          </h4>
          <div className="col-lg-6 mb-2"></div>
          <div className="row">
            {payoutVerified === null ? (
              <p className="tw-text-sm tw-text-gray-500">Checking your payout account…</p>
            ) : payoutVerified ? (
              <div className="alert alert-success" role="status">
                <p className="tw-mb-2">Your payout method is already verified with Stripe.</p>
                {payoutAccount && (
                  <div className="tw-text-sm tw-mb-2">
                    <strong className="tw-capitalize">{payoutAccount.bank_name}</strong>
                    {payoutAccount.default_for_currency && (
                      <span className="tw-capitalize tw-bg-blue-500 tw-text-white tw-text-xs tw-p-1 tw-rounded tw-mx-2">
                        Primary
                      </span>
                    )}
                    <p className="tw-mb-0">Routing number: {payoutAccount.routing_number}</p>
                    <p className="tw-mb-0">Account number: XXXXXXXXXXXX{payoutAccount.last4}</p>
                  </div>
                )}
                <p className="tw-mb-0">You're all set — click Save &amp; Next to continue.</p>
              </div>
            ) : (
              <ConnectComponentsProvider connectInstance={stripeConnectInstance}>
                <ConnectAccountOnboarding
                    onExit={() => {
                        updateStripeUserAccout();
                    }}
                    />
                </ConnectComponentsProvider>
            )}
          </div>
        </div>
        <div className=" payout-property-margin" >
          <button
            onClick={onPrev}
            type="button"
            className="btn btn-secondary mx-2  tw-mb-2"
          >
            Prev
          </button>
          <button
            disabled={!isButtonDisable}
            //type="submit"
            onClick={e=>handleNextStep(e)}
           // onClick={e=>{e.preventDefault(); e.stopPropagation();}}
            className="btn btn-secondary tw-mb-2"
          >
            Save & Next
          </button>
          
        </div>
      </div>
    </form>
  );
};
